<div class="ajaxOverlay">
    <i class="porto-loading-icon"></i>
</div>